<template lang="html">
  <div class="Subscribe">
    <p>Work in progress. Please <a href="http://eepurl.com/gRETMT" title="link to subscription form" class="subscribe-link">subscribe</a> to be informed when we are ready to go</p>
  </div>
</template>

<script>
export default {
  name: 'subscribe'
}
</script>

<style lang="css" scoped>
.Subscribe {
  display: flex;
  justify-content: center;
}
p {
  text-align: center;
  max-width: 32rem;
  margin: 1rem 0;
  line-height: 170%;
}
</style>
